export class DataTransformersHelper {
    static tokenizeSearchText(searchText: string): string[] {
        return searchText.split(/\s+/).filter(token => token.length > 0);
    }

    static matchesAllTokens(text: string, tokens: string[]): boolean {
        const lowerText = text.toLowerCase();
        return tokens.every(token => lowerText.includes(token));
    }

    static filterByVariableCode(variableTabData: any[], variableCode: string, responseCode?: string): any[] {
        return variableTabData.filter(
            (a: any) =>
                a.variable_code === variableCode &&
                (responseCode ? a.response_code === responseCode : true)
        );
    }

    static getDistinctValues<T, K extends keyof T>(list: T[], key: K): T[K][] {
        return [...new Set(list.map((item) => item[key]))];
    }

    static getDistinctLevel0Values(list: any[]) {
        return DataTransformersHelper.getDistinctValues(list, 'Level0');
    }

    static getDistinctLevel1Values(list: any[]) {
        return DataTransformersHelper.getDistinctValues(list, 'Level1');
    }

    static sortByChildIndex(items: any[], referenceData: any[]): void {
        items.sort((a, b) => {
            const indexA = referenceData.findIndex(data => data.Child === a.Child);
            const indexB = referenceData.findIndex(data => data.Child === b.Child);
            return indexA - indexB;
        });
    }

    static isDimensionPresent(list: any[]): boolean {
        return list.some((entry) => entry.is_dimension === true);
    }

    static isLevel1TimePeriodPresent(list: any[]): boolean {
        return list.some((entry) => entry.Level0 === 'Time Period');
    }

    static getDistinctAggregaredMetrics(list: any[]) {
        const distinctLevel0Values = [...new Set(list.map((item) => item.Level0))];
        return distinctLevel0Values;
    }

    static getDistinctENtryList(list: any[]) {
        const distinctLevel0Values = [...new Set(list.map((item) => item.Level1))];
        return distinctLevel0Values;
    }

    static checkBrands(metrics: string[]): number {
        let hasDelimiter = metrics.some((metric) => metric.includes('|'));
        if (!hasDelimiter) return 0;

        let firstParts = metrics.map((metric) => metric.split('|')[0]);
        let uniqueFirstParts = Array.from(new Set(firstParts));

        if (uniqueFirstParts.length === 1) {
            return 1;
        } else if (uniqueFirstParts.every((part) => part[0] === uniqueFirstParts[0][0])) {
            return 2;
        } else {
            return 3;
        }
    }

    static checkMetrics(metrics: string[]): number {
        return this.checkBrands(metrics); // Identical logic
    }

    static handlemetricname(metricName: any, type: number = 0) {
        if (type == 0) return metricName;
        else if (type == 1) {
            const parts = metricName.split('|');
            return parts[1];
        }

        const parts = metricName.split('|');
        if (parts.length <= 2) {
            return metricName;
        }

        return parts.slice(-2).join('|').trim();
    }

    static handleBrandName(metricName: any, type: number = 0) {
        return this.handlemetricname(metricName, type); // Identical logic
    }
}
